import seizureSafeIcon from "../../icons/seizureSafeIcon.svg"
import adhdIcon from "../../icons/adhdIcon.svg"
import cognitiveDisabilityIcon from "../../icons/cognitiveDisabilityIcon.svg"

export default [
    {
        label: 'Seizure Safe',
        key: 'seizure-safe-profile',
        icon: seizureSafeIcon
    },
    {
        label: 'ADHD',
        key: 'adhd-profile',
        icon: adhdIcon
    },
    {
        label: 'Cognitive Disability',
        key: 'cognitive-disabilities-profile',
        icon: cognitiveDisabilityIcon
    }
]